import React, { useEffect, useState } from "react";

import PageTitle from "../../layouts/PageTitle";

import {
  Modal,
  Button,
  Form,
  Badge,
} from "react-bootstrap";

const ImageAlt = () => {

  const [alts, setAlts] = useState([]);

  const [message, setMessage] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);

  const [selectedId, setSelectedId] = useState(null);

  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    image_name: "",
    alt_text: "",
  });

  useEffect(() => {
    fetchAlts();
  }, []);

  const fetchAlts = async () => {

    const res = await fetch(
      "https://admin.drgargevascular.com/backend/image-alt"
    );

    const data = await res.json();

    setAlts(Array.isArray(data) ? data : []);
  };

  const showAlert = (msg) => {

    setMessage(msg);

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ================= SAVE / UPDATE =================

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const url = editingId
        ? `https://admin.drgargevascular.com/backend/image-alt/${editingId}`
        : "https://admin.drgargevascular.com/backend/image-alt";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {

        method,

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(form),
      });

      if (res.ok) {

        showAlert(
          editingId
            ? "Alt Text Updated Successfully"
            : "Alt Text Added Successfully"
        );

        setForm({
          image_name: "",
          alt_text: "",
        });

        setEditingId(null);

        setShowModal(false);

        fetchAlts();

      } else {

        showAlert("Failed");

      }

    } catch (err) {

      console.log(err);

      showAlert("Something went wrong");

    }
  };

  // ================= EDIT =================

  const handleEdit = (item) => {

    setEditingId(item.id);

    setForm({
      image_name: item.image_name,
      alt_text: item.alt_text,
    });

    setShowModal(true);
  };

  // ================= DELETE =================

  const openDeleteModal = (id) => {

    setSelectedId(id);

    setDeleteModal(true);
  };

  const confirmDelete = async () => {

    try {

      const res = await fetch(
        `https://admin.drgargevascular.com/backend/image-alt/${selectedId}`,
        {
          method: "DELETE",
        }
      );

      if (res.ok) {

        showAlert("Deleted Successfully");

        fetchAlts();

      } else {

        showAlert("Delete Failed");

      }

    } catch (err) {

      console.log(err);

      showAlert("Something went wrong");

    }

    setDeleteModal(false);

    setSelectedId(null);
  };

  // ================= RESET =================

  const closeModal = () => {

    setShowModal(false);

    setEditingId(null);

    setForm({
      image_name: "",
      alt_text: "",
    });
  };

  return (
    <>
      <PageTitle
        activeMenu="Image Alt"
        motherMenu="CMS"
      />

      <div className="row">

        <div className="col-xl-12">

          {message && (

            <div className="alert alert-success border-0 shadow-sm rounded-3">

              {message}

            </div>

          )}

          <div className="card shadow-sm border-0 rounded-4">

            <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center py-3">

              <div>

                <h4 className="mb-1 fw-bold">

                  Image Alt Text

                </h4>

                <small className="text-muted">

                  Manage SEO Alt Texts

                </small>

              </div>

              <button
                className="btn btn-primary px-4 rounded-pill"
                onClick={() => setShowModal(true)}
              >

                + Add Alt Text

              </button>

            </div>

            <div className="card-body">

              <div className="table-responsive">

                <table className="table table-hover align-middle">

                  <thead className="table-light">

                    <tr>

                     

                      <th>Image Name</th>

                      <th>Alt Text</th>

                      <th width="180">Actions</th>

                    </tr>

                  </thead>

                  <tbody>

                    {alts.map((item) => (

                      <tr key={item.id}>

                        
                        <td className="fw-semibold">

                          {item.image_name}

                        </td>

                        <td>

                          {item.alt_text}

                        </td>

                        <td>

                          <div className="d-flex gap-2">

                            <button
                              className="btn btn-warning btn-sm rounded-pill px-3"
                              onClick={() => handleEdit(item)}
                            >

                              Edit

                            </button>

                            <button
                              className="btn btn-danger btn-sm rounded-pill px-3"
                              onClick={() =>
                                openDeleteModal(item.id)
                              }
                            >

                              Delete

                            </button>

                          </div>

                        </td>

                      </tr>

                    ))}

                    {alts.length === 0 && (

                      <tr>

                        <td
                          colSpan="4"
                          className="text-center py-5 text-muted"
                        >

                          No Data Found

                        </td>

                      </tr>

                    )}

                  </tbody>

                </table>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ================= ADD / EDIT MODAL ================= */}

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
      >

        <Modal.Header closeButton>

          <Modal.Title>

            {editingId
              ? "Update Image Alt"
              : "Add Image Alt"}

          </Modal.Title>

        </Modal.Header>

        <Form onSubmit={handleSubmit}>

          <Modal.Body>

            <Form.Group className="mb-3">

              <Form.Label>

                Image Name

              </Form.Label>

              <Form.Control
                type="text"
                name="image_name"
                value={form.image_name}
                onChange={handleChange}
                placeholder="example.jpg"
                required
              />

            </Form.Group>

            <Form.Group>

              <Form.Label>

                Alt Text

              </Form.Label>

              <Form.Control
                type="text"
                name="alt_text"
                value={form.alt_text}
                onChange={handleChange}
                placeholder="Enter SEO Alt Text"
                required
              />

            </Form.Group>

          </Modal.Body>

          <Modal.Footer>

            <Button
              variant="light"
              onClick={closeModal}
            >

              Cancel

            </Button>

            <Button
              variant="primary"
              type="submit"
            >

              {editingId
                ? "Update"
                : "Save"}

            </Button>

          </Modal.Footer>

        </Form>

      </Modal>

      {/* ================= DELETE CONFIRMATION ================= */}

      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        centered
      >

        <Modal.Body className="text-center p-5">

          <div
            className="mx-auto mb-4 d-flex align-items-center justify-content-center"
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "#ffe5e5",
              fontSize: "35px",
              color: "#dc3545",
            }}
          >

            🗑️

          </div>

          <h4 className="fw-bold mb-3">

            Delete Alt Text?

          </h4>

          <p className="text-muted mb-4">

            This action cannot be undone.
            Are you sure you want to delete this record?

          </p>

          <div className="d-flex justify-content-center gap-3">

            <Button
              variant="light"
              className="px-4 rounded-pill"
              onClick={() =>
                setDeleteModal(false)
              }
            >

              Cancel

            </Button>

            <Button
              variant="danger"
              className="px-4 rounded-pill"
              onClick={confirmDelete}
            >

              Yes Delete

            </Button>

          </div>

        </Modal.Body>

      </Modal>

    </>
  );
};

export default ImageAlt;